import axios from 'axios';
import {backendHost} from '../../config';

export const updateUsers = (params) => {
    return axios.put(`${backendHost}/api/admin/v2/mailing/users`, params);
};